/**
 * Checks if text a contains text b and is case-insensitive
 * @param text
 * @param search
 */
export const contains = (
	text: string,
	search: string | string[],
	mustContainAllParts: boolean = false
): boolean => {
	if (!text) return false;
	if (text && search === undefined) return true;
	if (text === undefined && search === undefined) return false;

	/**
	 * Checking if Either of the entries exists
	 */
	if (Array.isArray(search)) {
		const numberOfMatches = search.filter(query => contains(text, query)).length;
		/**
		 * If we require the text to contain all the queries
		 */
		if (mustContainAllParts) {
			return numberOfMatches === search.length;
		}
		/**
		 * If we only require one or more matches
		 */
		return numberOfMatches > 0;
	}

	return `${text || ''}`.toLowerCase().indexOf(`${search || ''}`.toLowerCase()) > -1;
};